import {
  IconBrandInstagram,
  IconBrandTiktok,
  IconBrandYoutube,
  IconBrandFacebook,
  IconBrandStrava,
  IconLink,
  IconNotes,
  IconHeading,
  IconLayoutGrid,
  IconMail,
} from '@tabler/icons-react';
import type { BioBlock } from '@/lib/link-in-bio/model';
export function BioBlockIcon({
  block,
  platform,
}: {
  block: Pick<BioBlock, 'type' | 'url'>;
  platform?: string;
}) {
  if (block.type === 'heading') return <IconHeading size={20} />;
  if (block.type === 'text') return <IconNotes size={18} />;
  if (block.type === 'collection') return <IconLayoutGrid size={20} />;
  if (block.type === 'message') return <IconMail size={20} />;
  if (block.url.startsWith('mailto:')) return <IconMail size={20} />;
  let host = '';
  try {
    host = new URL(block.url).hostname;
  } catch {
    /* Unsaved link. */
  }
  const matches = (name: string) =>
    platform === name || host === `${name}.com` || host.endsWith(`.${name}.com`);
  if (matches('instagram')) return <IconBrandInstagram size={20} />;
  if (matches('tiktok')) return <IconBrandTiktok size={20} />;
  if (matches('youtube') || host === 'youtu.be') return <IconBrandYoutube size={20} />;
  if (matches('facebook')) return <IconBrandFacebook size={20} />;
  if (matches('strava') || host === 'strava.app.link') return <IconBrandStrava size={20} />;
  return <IconLink size={20} />;
}
